import React, { useState } from "react";
import { AuthWrapper } from "../AuthWrapper";
import backArrow from "../assets/back-button.png";
import { toast } from "react-toastify";
import { fetchApi } from "../utlis/axios";
import { IoMdClose } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-number-input";

const RegisterMedicalStore = ({setShowModal}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { access } = useSelector((state) => state.authSlice.userInfo);

  const [formValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    userName: "",
    email: "",
    medicalStoreName: "",
    phoneNumber: "",
    address: "",
    city: "",
    state: "",
  });

  const PostRegistration = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const data = new FormData();
      data.append("first_name", formValues?.first_name);
      data.append("last_name", formValues?.last_name);
      data.append("username", formValues?.userName);
      data.append("email", formValues?.email);

      const result = await fetchApi.post("pharmacist/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access}`,
        },
      });
      if (result?.status === 201) {
        try {
          const formData = new FormData();
          formData.append("user", result?.data?.id);
          formData.append("name", formValues?.medicalStoreName);
          formData.append("phone_number", formValues?.phoneNumber);
          formData.append("address", formValues?.address);
          formData.append("city", formValues?.city);
          formData.append("state", formValues?.state);
          formData.append("is_active", true);

          await fetchApi.post("medical-store/", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${access}`,
            },
          });

          if (result?.status === 201) {
            toast.success("Successfully Register");
            navigate("/dashboard/kwf_medical_staff");
          }
          setFormValues({
            ...formValues,
            first_name: "",
            last_name: "",
            userName: "",
            email: "",
            medicalStoreName: "",
            phoneNumber: "",
            address: "",
            city: "",
            state: "",
          });
        } catch (error) {
          console.log({ error });
        }
      }
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.username?.[0]);
      toast.error(error?.response?.data?.email?.[0]);
    } finally {
      setLoading(false); // Set loading back to false when API call is completed
    }
  };

  const handleGoBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <AuthWrapper>
     <div className="fixed inset-0 z-[100] flex justify-center ">
        {/* backdrop */}
        <div
          className="absolute inset-0 bg-black/50"
          onClick={() => setShowModal(false)}
        ></div>

        {/* modal wrapper */}
        <div className="flex items-center justify-center overflow-y-auto w-full min-h-screen py-8 md:py-16 px-[16px] sm:px-4">
          <div className="relative z-[200] w-full max-w-4xl my-auto">
            <div className="bg-[#FCFBF7] rounded-3xl shadow-xl">
              {/* Close button */}
              <button
                className="absolute w-max top-4 right-4 text-gray-700 bg-primary-green/10 p-1 rounded-full cursor-pointer                        hover:text-gray-700 text-2xl"
                onClick={() => setShowModal(false)}
              >
                <IoMdClose className="text-black"/>
              </button>

              {/* Header */}
              <div className="sm:px-6 px-[12px]">
              <div className=" pt-6 pb-4 border-b border-[#444444] w-full">
                <h2 className="md:text-4xl text-2xl font-bold text-gray-800">
                  Medical Store Registration
                </h2>
              </div>
              </div>
              <div className="field_Container" style={{marginTop:0}}>
                <>
                  <form onSubmit={PostRegistration} className="form_responsive">
                    <div className="font-semibold py-2 text-2xl mb-2">
                      Manager Detail
                    </div>
                    <div className="group-fields">
                      <div className="field-container">
                        <h6 className="field-txt !text-lg">First name</h6>
                        <input
                          type="text"
                          id="First name"
                          name="First name"
                          placeholder="First Name"
                          className="formField"
                          value={formValues?.first_name}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              first_name: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div className="field-container">
                        <h6 className="field-txt !text-lg">Last Name</h6>
                        <input
                          type="text"
                          id="Last Name"
                          name="Last Name"
                          placeholder="Last Name"
                          className="formField"
                          value={formValues?.last_name}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              last_name: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>
                    <div className="group-fields">
                      <div className="field-container">
                        <h6 className="field-txt !text-lg">User Name</h6>
                        <input
                          type="text"
                          id="userName"
                          name="userName"
                          placeholder="User Name"
                          className="formField"
                          value={formValues?.userName}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              userName: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div className="field-container">
                        <h6 className="field-txt !text-lg">Email</h6>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          placeholder="Email"
                          className="formField"
                          value={formValues?.email}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              email: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>
                    <div className="font-semibold py-2 text-2xl mb-2">
                      Meddical Store Detail
                    </div>
                    <div className="group-fields">
                      <div className="field-container">
                        <h6 className="field-txt !text-lg">Name</h6>
                        <input
                          type="text"
                          id="medicalStorename"
                          name="medicalStorename"
                          placeholder="Medical Store name"
                          className="formField"
                          value={formValues?.medicalStoreName}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              medicalStoreName: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div
                        className="field-container"
                      >
                        <h6 className="field-txt !text-lg">Phone Number</h6>
                        <PhoneInput
                          type="text"
                          value={formValues?.phoneNumber}
                          name="phoneNumber"
                          placeholder="Enter phone number"
                          className="formField"
                          required
                          onChange={(value) =>
                            setFormValues({
                              ...formValues,
                              phoneNumber: value,
                            })
                          }
                          style={{
                            display: "flex",
                            background: "white",
                            borderRadius: "10px",
                            padding: "0px 10px",
                            border: "1px solid #444444",
                            overflow: "hidden",
                          }}
                        />
                      </div>
                    </div>
                    <div className="group-fields">
                      <div className="field-container">
                        <h6 className="field-txt !text-lg">City</h6>
                        <input
                          type="text"
                          id="City"
                          name="City"
                          placeholder="City"
                          className="formField"
                          value={formValues?.city}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              city: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div className="field-container">
                        <h6 className="field-txt !text-lg">State</h6>
                        <input
                          type="text"
                          id="state"
                          name="state"
                          placeholder="State"
                          className="formField"
                          value={formValues?.state}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              state: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>
                    <div className="group-fields">
                    <div className="field-container">
                        <h6 className="field-txt !text-lg">Address</h6>
                        <input
                          type="text"
                          id="address"
                          name="address"
                          placeholder="address"
                          className="formField"
                          value={formValues?.address}
                          onChange={(e) =>
                            setFormValues({
                              ...formValues,
                              address: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>
                    <div className="pb-3 sm:pt-0 pt-[20px]">
                      <button className="!font-quicksand primary-button" disabled={loading} style={{fontFamily:'',fontWeight:500}}>
                        {loading ? "Loading..." : "Register Medical Store"}
                      </button>
                    </div>
                  </form>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthWrapper>
  );
};

export default RegisterMedicalStore;
